module.exports = "/_next/static/images/kiyma_curry-2b7de275cb11bf260e7caaea9e74087a.jpg";